import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import cn from 'classnames';
// eslint-disable-next-line import/named
import { type IntlShape } from 'react-intl';

import './TrackingHistoryInfo.scss';

const ns = 'tracking-history-info';

type Props = {
  state: String,
  date?: String,
  time?: String,
  lastState: Boolean,
  inProgress: Boolean,
  isCompleted: Boolean,
  isToday?: Boolean,
  intl: IntlShape,
  current?: Boolean
};

const TrackingHistoryInfo = (props: Props) => {
  const {
    state,
    date,
    time,
    lastState,
    inProgress,
    isCompleted,
    isToday,
    intl,
    current
  } = props;
  const infoClassName = cn({
    [`${ns}__status-info`]: true,
    'in-progress': inProgress,
    normal: !inProgress
  });
  const ariaEnabled = !lastState || current;
  let status = ' ';
  let ariaStatus = !lastState
    ? ': ' +
      intl.formatMessage({
        id: 'c8.status.tracker.not.yet.started',
        defaultMessage: 'Not yet started'
      })
    : ' ';

  if (isCompleted) {
    status = intl.formatMessage({
      id: 'c8.status.tracker.completed'
    });
    ariaStatus = status;
  }

  if (inProgress) {
    status = intl.formatMessage({
      id: 'c8.status.tracker.in.progress'
    });
    ariaStatus = status;
  }

  return (
    <Container className={ns} fluid={true}>
      <Row className={`${ns}__first-row`}>
        <Col xs={'8'}>
          <div
            className={`${ns}__state`}
            tabIndex={ariaEnabled ? 0 : -1}
            aria-label={`${state} ${ariaStatus}`}
            aria-hidden={!ariaEnabled}
          >
            {state}
          </div>
        </Col>
        <Col xs={'4'} className={'pr-3'}>
          <div className={`${ns}__time`}>
            <div>
              {isToday
                ? intl.formatMessage({
                    id: 'c8.status.tracker.today'
                  })
                : date}
            </div>
            <div>{time}</div>
          </div>
        </Col>
      </Row>
      <Row className={`${ns}__second-row`}>
        <Col>
          <div className={infoClassName}>{status}</div>
        </Col>
      </Row>
      {lastState === false && (
        <Row>
          <Col>
            <div className={`${ns}__border`} />
          </Col>
        </Row>
      )}
    </Container>
  );
};

export default TrackingHistoryInfo;



// WEBPACK FOOTER //
// ./src/components/atoms/TrackingHistoryInfo/TrackingHistoryInfo.js